export const getLanguage = (language: string): 'se' | 'en' | 'fi' => {
  if (language.includes('sv')) {
    return 'se'
  }
  if (language.includes('en')) {
    return 'en'
  }
  if (language.includes('fi')) {
    return 'fi'
  }
  return 'se'
}

export const getLanguageBCP47 = (language: string): 'sv' | 'en' | 'fi' => {
  if (language.includes('sv')) {
    return 'sv'
  }
  if (language.includes('en')) {
    return 'en'
  }
  if (language.includes('fi')) {
    return 'fi'
  }
  return 'sv'
}

const swedish = {
  label: 'Svenska 🇸🇪',
  value: 'sv-SE',
  dateFns: 'sv',
  locale: 'sv',
}
const english = {
  label: 'English 🇬🇧',
  value: 'en-EN',
  dateFns: 'enGB',
  locale: 'en',
}
const finnish = {
  label: 'Suomi 🇫🇮',
  value: 'fi-FI',
  dateFns: 'fi',
  locale: 'fi',
}

export const getLanguageOption = (
  language: string
): { label: string; value: string; dateFns: string; locale: string } => {
  if (language.includes('sv') || language.includes('se')) {
    return swedish
  }
  if (language.includes('en')) {
    return english
  }
  if (language.includes('fi')) {
    return finnish
  }
  return swedish
}
